import { api } from "../../../api/api";
import {
  getContentType,
  getFileUploadWarningMessage,
  shouldCompressFile,
  shouldConvertFile,
} from "../../FileUploadIcon/helpers";

interface IUploadFilePayload {
  file: File | null;
  module_name: string;
  defaultReturn: string;
  asPayload: {
    [key: string]: string | number | null;
  };
  onWarning?: (message: string) => void;
}

export const uploadFile = async ({
  file,
  module_name,
  defaultReturn,
  asPayload,
  onWarning,
}: IUploadFilePayload) => {
  if (file) {
    const formdata = new FormData();

    const isConvertTrue = shouldConvertFile(file);
    const isCompressedTrue = shouldCompressFile(file);

    const warningMessage = getFileUploadWarningMessage(
      isConvertTrue,
      isCompressedTrue
    );
    if (warningMessage && onWarning) {
      onWarning(warningMessage);
    }

    const options = {
      convert: isConvertTrue,
      compressed: isCompressedTrue,
    };

    const contentType = getContentType(file);

    const file_metadata = {
      ContentType: contentType.toLowerCase(),
      ContentDisposition: "attachment",
    };

    formdata.append("files", file);
    formdata.append("module_name", module_name);
    formdata.append("as_payload", JSON.stringify(asPayload));
    formdata.append("options", JSON.stringify(options));
    formdata.append("file_metadata", JSON.stringify(file_metadata));

    const res = await api.post("/general/upload-files", formdata);
    const data: string[] = res.data.data;
    if (data.length > 0) {
      return data[0];
    }
  }
  return defaultReturn;
};

interface IUploadOnboardingFilePayload {
  file: File | null;
  module_name: string;
  defaultReturn: string;
  asPayload: {
    [key: string]: string | number | null;
  };
  headers?: {
    [key: string]: string;
  };
  onWarning?: (message: string) => void;
}
export const uploadOnboardingFile = async ({
  file,
  module_name,
  defaultReturn,
  asPayload,
  headers,
  onWarning,
}: IUploadOnboardingFilePayload) => {
  if (file) {
    const formdata = new FormData();

    const isConvertTrue = shouldConvertFile(file);
    const isCompressedTrue = shouldCompressFile(file);

    const warningMessage = getFileUploadWarningMessage(
      isConvertTrue,
      isCompressedTrue
    );
    if (warningMessage && onWarning) {
      onWarning(warningMessage);
    }

    const options = {
      convert: isConvertTrue,
      compressed: isCompressedTrue,
    };

    const contentType = getContentType(file);

    const file_metadata = {
      ContentType: contentType.toLowerCase(),
      ContentDisposition: "attachment",
    };

    formdata.append("files", file);
    formdata.append("module_name", module_name);
    formdata.append("as_payload", JSON.stringify(asPayload));
    formdata.append("options", JSON.stringify(options));
    formdata.append("file_metadata", JSON.stringify(file_metadata));

    const res = await api.post("/general/upload-files-onbarding", formdata, {
      headers: headers || {},
    });
    const data: string[] = res.data.data;
    if (data.length > 0) {
      return data[0];
    }
  }
  return defaultReturn;
};
